// extracted by mini-css-extract-plugin
module.exports = {"wrap":"RevealCard_wrap__QqAWV","back":"RevealCard_back__JTKsJ","confetti":"RevealCard_confetti__253QC"};